import { Estados, estados } from "@/types/api"
import { defineStore } from "pinia"
import AtributosRepositorio from "@/repositorios/atributos/atributos.repositorio"
import {
  AtributoBase,
  ParamsAtributo,
} from "@/repositorios/atributos/atributos.modelos"
import {
  Paginador,
  usarLeitorDeDados,
} from "@/composable/UsarLeitorDeDados/usarLeitorDeDados"
import { TiposPossiveis } from "@/types/atributo"

interface AtributoStore {
  leitorAtributos: Paginador<AtributoBase, ParamsAtributo>
  listaAtributos: AtributoBase<boolean>[]
  atributo?: AtributoBase
  estagioDaRequisicao: { listar_atributo: Estados; criar_atributo: Estados }
}
type TipoChaves = "criar_atributo" | "listar_atributo"

const { leitor } = usarLeitorDeDados()
const atributoRepositorio = new AtributosRepositorio()
const lerAtributos = leitor<AtributoBase, ParamsAtributo>(
  atributoRepositorio.listarAtributos,
  {}
)

export const AtributoStore = defineStore("criar-atributo", {
  state: (): AtributoStore => ({
    leitorAtributos: lerAtributos,
    listaAtributos: [],
    estagioDaRequisicao: {
      criar_atributo: estados.INICIAL,
      listar_atributo: estados.INICIAL,
    },
  }),
  getters: {
    carregando(state) {
      return (tipo: TipoChaves) =>
        state.estagioDaRequisicao[tipo] === estados.PEDENTE
    },
    erro(state) {
      return (tipo: TipoChaves) =>
        state.estagioDaRequisicao[tipo] === estados.ERRO
    },
    sucesso(state) {
      return (tipo: TipoChaves) =>
        state.estagioDaRequisicao[tipo] === estados.SUCESSO
    },
  },
  actions: {
    async salvarEAdicionarAtributo(atributo: AtributoBase) {
      this.estagioDaRequisicao["criar_atributo"] = estados.PEDENTE

      try {
        const { id } = await atributoRepositorio.criarNovoAtributo(atributo)

        await this.listarAtributos("igual." + id)

        this.estagioDaRequisicao["criar_atributo"] = estados.SUCESSO
        return Promise.resolve()
      } catch (erro) {
        this.estagioDaRequisicao["criar_atributo"] = estados.ERRO

        return Promise.reject(erro)
      }
    },
    async listarAtributos(
      idParam?: string,
      idOpTipoDeRecurso?: string,
      pagina = 0,
      porPagina = 1000
    ) {
      this.estagioDaRequisicao["listar_atributo"] = estados.PEDENTE

      lerAtributos.sobrescreverParametros({
        id: idParam,
        tipo_de_recurso: idOpTipoDeRecurso,
      })

      await lerAtributos.porPagina(porPagina).pagina(pagina).executar()

      if (lerAtributos.resultado.status === "sucesso") {
        this.listaAtributos.unshift(...lerAtributos.resultado.dados)
        this.estagioDaRequisicao["listar_atributo"] = estados.SUCESSO
      }
      if (lerAtributos.resultado.status === "erro") {
        this.estagioDaRequisicao["listar_atributo"] = estados.ERRO
      }
      if (lerAtributos.resultado.status === "vazio") {
        this.estagioDaRequisicao["listar_atributo"] = estados.SUCESSO
      }
    },
    async listarAtributosTipoDeAtividade(id: string[], pagina = 0, porPagina = 1000) {
      this.estagioDaRequisicao["listar_atributo"] = estados.PEDENTE

      lerAtributos.sobrescreverParametros({
        id: `em.(${id.join(",")})`
      })

      await lerAtributos.porPagina(porPagina).pagina(pagina).executar()

      if (lerAtributos.resultado.status === "sucesso") {
        this.listaAtributos.unshift(...lerAtributos.resultado.dados)
        this.estagioDaRequisicao["listar_atributo"] = estados.SUCESSO
      }
      if (lerAtributos.resultado.status === "erro") {
        this.estagioDaRequisicao["listar_atributo"] = estados.ERRO
      }
      if (lerAtributos.resultado.status === "vazio") {
        this.estagioDaRequisicao["listar_atributo"] = estados.SUCESSO
      }
    },
    async listarAtributosComValoresTipoDeAtividade(id: string, pagina = 0, porPagina = 1000) {
      this.estagioDaRequisicao["listar_atributo"] = estados.PEDENTE

      lerAtributos.sobrescreverParametros({
        id: `igual.${id}`
      })

      await lerAtributos.porPagina(porPagina).pagina(pagina).executar()

      if (lerAtributos.resultado.status === "sucesso") {
        this.listaAtributos.unshift(...lerAtributos.resultado.dados)
        this.estagioDaRequisicao["listar_atributo"] = estados.SUCESSO
      }
      if (lerAtributos.resultado.status === "erro") {
        this.estagioDaRequisicao["listar_atributo"] = estados.ERRO
      }
      if (lerAtributos.resultado.status === "vazio") {
        this.estagioDaRequisicao["listar_atributo"] = estados.SUCESSO
      }
    },
    adicionarAtributo(atributo: AtributoBase) {
      this.listaAtributos.unshift(atributo)
    },
  },
})
